var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"with-close-icon-wrapper",class:( _obj = {
    'with-shadow': _vm.showShadowOnIcon
  }, _obj['icon-' + _vm.iconAlignment] = true, _obj ),style:(_vm.wrapperStyle)},[_c('div',{staticClass:"item",class:_vm.itemWrapperClass},[_vm._t("default"),_vm._v(" "),_c('i',{staticClass:"dismiss",class:( _obj$1 = {
        'close-icon': _vm.closeIconColor === 'grey',
        'close-white-icon': _vm.closeIconColor === 'white'
      }, _obj$1[_vm.iconAlignment] = true, _obj$1 ),attrs:{"tabindex":"0","title":_vm.dismissTitle},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close', $event)}}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }